import UnionFilterIcon from '../../../../../assets/svgs/UnionFilter'

import style from './style.module.css'

const FilterHeader = ({
  setIsFilterOpen,
  mobileFilterButtonChoice,
  setMobileFilterButtonChoice,
}) => {
  const filterButtons = ['All', 'Save', 'Private Company']

  return (
    <div className={style.filterHeader}>
      <div className={style.filterHeader_buttons}>
        {filterButtons.map((button) => (
          <div
            className={`${style.filterHeader_button} ${
              mobileFilterButtonChoice === button.toLowerCase() && style.active
            }`}
            onClick={() => setMobileFilterButtonChoice(button.toLowerCase())}
          >
            <span>{button}</span>
          </div>
        ))}
      </div>

      <div
        className={style.filterHeader_trigger}
        onClick={() => setIsFilterOpen(true)}
      >
        <span>
          Filter <UnionFilterIcon />
        </span>
      </div>
    </div>
  )
}

export default FilterHeader
